import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';

import { formatTimestamp } from '../helpers/formatting';

export default function Review(data) {
  return (
    <tr>
      <td>{data.reviewData.customer.name}</td>
      <td>{data.reviewData.rating.emoji} {data.reviewData.rating.label}</td>
      <td>{data.reviewData.review}</td>
      <td>{formatTimestamp(data.reviewData.created_at)}</td>
    </tr>
  );
}


